import { FaArrowUpRightFromSquare } from "react-icons/fa6";

const clients = [
  {
    name: "Ambumeadow Limited",
    project: "Hospital Management System",
    description:
      "A web-based healthcare management system designed to streamline hospital operations, patient records, and healthcare service delivery.",
    website: "https://www.ambumeadow.com",
    type: "Client Project",
  },
  {
    name: "ChamaVault",
    project: "Group Savings & Investment Platform",
    description:
      "A digital platform for managing group savings, member contributions, loans, investments, and financial activities.",
    website: "https://www.chamavault.online",
    type: "Client Project",
  },
  {
    name: "VinCab",
    project: "Ride-Hailing Platform",
    description:
      "A modern ride-hailing platform connecting passengers with drivers for convenient, reliable, and efficient transportation.",
    website: "https://www.vincab.services",
    type: "Client Project",
  },
  {
    name: "Open Gate Foundation",
    project: "NGO Website",
    description:
      "A professional digital presence designed to showcase the foundation's mission, programs, activities, and community impact.",
    website: "https://www.ogfkenya.org",
    type: "Client Project",
  },
  {
    name: "ShopScan",
    project: "Smart Retail Management Platform",
    description:
      "A retail management solution that helps shop owners manage inventory, track sales, scan barcodes, and understand business performance.",
    website: "https://www.shopscanapp.com",
    type: "Nexindi Product",
  },
  {
    name: "Ticowe Green Africa",
    project: "NGO Web Platform",
    description:
      "A modern web platform designed to strengthen the organization's digital presence, outreach, programs, and community engagement.",
    website: "https://www.ticowegreenafrica.com",
    type: "Client Project",
  },
  {
    name: "Tumaini Bridge",
    project: "NGO Website",
    description:
      "A digital platform created to showcase the organization's mission, programs, impact, and opportunities for community involvement.",
    website: "https://tumainibridge.or.ke/",
    type: "Client Project",
  },
  {
    name: "Karibu Event",
    project: "Event Management & Ticketing Platform",
    description:
      "An event platform that enables organizers to publish and manage events while attendees discover events, book tickets, pay via M-Pesa, and receive QR-code tickets.",
    website: "https://www.karibuevent.online/",
    type: "Nexindi Product",
  },
  {
    name: "Crib",
    project: "Property Discovery Platform",
    description:
      "A rental discovery platform connecting house hunters with landlords, making it easier to discover properties, compare options, and request viewings.",
    website: "https://www.cribapp.online/",
    type: "Nexindi Product",
  },
  {
  name: "PrintFlow",
  project: "Cloud Printing & Print Management Platform",
  description:
    "A smart document printing platform that allows customers to upload documents, configure print options, pay online, and have their documents automatically sent to a connected business printer through the PrintFlow Print Agent.",
  website: "https://www.print-flow-app.com/",
  type: "Nexindi Product",
},
];

export default function ClientsSection() {
  return (
    <section className="relative py-24 px-6 bg-slate-950 overflow-hidden">

      {/* Background glow */}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-600/10 rounded-full blur-[140px]" />

      <div className="absolute bottom-0 right-0 w-[450px] h-[450px] bg-blue-500/10 rounded-full blur-[130px]" />

      {/* Grid background */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.7) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.7) 1px, transparent 1px)
          `,
          backgroundSize: "50px 50px",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">

          <div className="max-w-3xl">

            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-blue-500/20 bg-blue-500/10 text-blue-300 text-sm font-semibold mb-6">
              <span className="w-2 h-2 bg-blue-400 rounded-full" />
              Our Work
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight">
              Technology we've built for
              <span className="text-blue-400"> real-world impact.</span>
            </h2>
          </div>

          <p className="max-w-md text-slate-400 text-lg leading-relaxed">
            From business platforms to our own digital products, we transform
            ideas and challenges into practical technology solutions.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

          {clients.map((client, i) => (
            <a
              key={i}
              href={client.website}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative flex flex-col min-h-[340px] p-8 rounded-3xl border border-white/10 bg-white/[0.04] backdrop-blur-sm overflow-hidden transition-all duration-500 hover:-translate-y-2 hover:border-blue-500/40 hover:bg-white/[0.07] hover:shadow-2xl hover:shadow-blue-950/40"
            >

              {/* Hover gradient */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              {/* Top */}
              <div className="relative z-10 flex items-start justify-between gap-4 mb-10">

                {/* Type */}
                <span
                  className={`inline-flex px-3 py-1.5 rounded-full text-xs font-semibold border ${
                    client.type === "Nexindi Product"
                      ? "bg-blue-500/15 border-blue-400/20 text-blue-300"
                      : "bg-white/5 border-white/10 text-slate-400"
                  }`}
                >
                  {client.type}
                </span>

                {/* Arrow */}
                <div className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-slate-400 transition-all duration-300 group-hover:bg-blue-600 group-hover:border-blue-600 group-hover:text-white">
                  <FaArrowUpRightFromSquare
                    size={14}
                    className="transition-transform duration-300 group-hover:translate-x-[2px] group-hover:-translate-y-[2px]"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="relative z-10 flex-1">

                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-blue-300 transition-colors duration-300">
                  {client.name}
                </h3>

                <p className="text-blue-400 font-semibold text-sm mb-5">
                  {client.project}
                </p>

                <p className="text-slate-400 leading-relaxed text-sm">
                  {client.description}
                </p>
              </div>

              {/* Bottom */}
              <div className="relative z-10 mt-8 pt-5 border-t border-white/10 flex items-center justify-between">

                <span className="text-sm text-slate-500 group-hover:text-slate-300 transition-colors">
                  View project
                </span>

                <span className="text-blue-400 text-lg transition-transform duration-300 group-hover:translate-x-1">
                  →
                </span>

              </div>

              {/* Decorative number */}
              <span className="absolute -bottom-6 -right-2 text-[100px] font-bold leading-none text-white/[0.02] group-hover:text-blue-500/[0.05] transition-colors duration-500 pointer-events-none">
                {String(i + 1).padStart(2, "0")}
              </span>

            </a>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-14 flex flex-col md:flex-row items-center justify-between gap-6 border-t border-white/10 pt-10">

          <p className="text-slate-400 text-center md:text-left">
            Have an idea or business challenge that needs technology?
          </p>

          <a
            href="/contact"
            className="group inline-flex items-center gap-3 px-7 py-4 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-500 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-blue-600/20"
          >
            Start a Project

            <span className="transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </a>

        </div>
      </div>
    </section>
  );
}